"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EdgeConfigLoadingStates = exports.Actions = void 0;
var Actions;
(function (Actions) {
    Actions["configChange"] = "config.change";
    Actions["configLoadingChange"] = "config.loadingChange";
    Actions["widgetDefaults"] = "config.widgetDefaults";
    Actions["loadingError"] = "config.loading.error";
})(Actions = exports.Actions || (exports.Actions = {}));
var EdgeConfigLoadingStates;
(function (EdgeConfigLoadingStates) {
    EdgeConfigLoadingStates["INITIAL"] = "initial";
    EdgeConfigLoadingStates["LOADING"] = "loading";
    EdgeConfigLoadingStates["LOADED"] = "loaded";
    EdgeConfigLoadingStates["ERROR"] = "error";
})(EdgeConfigLoadingStates = exports.EdgeConfigLoadingStates || (exports.EdgeConfigLoadingStates = {}));
